import React from "react";
import { Dialog, DialogActions, DialogContent, Button, Box } from "@mui/material";
import { downloadFile } from "src/utils/previewDownloadFile";
import { SCAMALERT_FILES_URL } from "src/api_endpoints/API_URL";

const ViewScamImagesModal = ({ openModal, handleCloseModal, currentImages }) => (
  <Dialog
    open={openModal}
    onClose={handleCloseModal}
    maxWidth="sm"
  >
    <DialogContent
       sx={{backgroundColor:"aliceblue"}}
    >
      {currentImages.map((attachment, index) => (
        <Box
          key={index}
          sx={{margin:"auto",width: {xs: "90%",sm: "50%"},cursor: "pointer"}}
          onClick={() => downloadFile([attachment], SCAMALERT_FILES_URL)}
        >
          <img
            src={`${SCAMALERT_FILES_URL}${attachment}`}
            alt={`Attachment ${index + 1}`}
            style={{width: "100%",height: "auto",objectFit: "contain"}}
          />
        </Box>
      ))}
    </DialogContent>
    <DialogActions>
      <Button onClick={handleCloseModal} color="primary">
        Close
      </Button>
    </DialogActions>
  </Dialog>
);

export default ViewScamImagesModal;
